import { ISupplierAddRequest } from '../../../../model/sge/supplier/request/supplier-add-edit-request';

export type SupplierCreateEditState = {
    supplierId?: string;
    supplierRequest: ISupplierAddRequest;
    showValidationErrors: boolean;
};

export enum ACTION_TYPES {
    setSupplierId = 'setSupplierId',
    setSupplierRequest = 'setSupplierRequest',
    updateSupplierRequest = 'updateSupplierRequest',
    updateAddress = 'updateAddress',
    updateContact = 'updateContact',
    updatePhysicalPerson = 'updatePhysicalPerson',
    updateLegalPerson = 'updateLegalPerson',
    setShowValidationErrors = 'setShowValidationErrors',
}

export const SupplierCreateEditReducer = (state: SupplierCreateEditState, action: any): SupplierCreateEditState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setSupplierId:
            return { ...state, supplierId: payload };
        case ACTION_TYPES.setSupplierRequest:
            return { ...state, supplierRequest: payload };
        case ACTION_TYPES.updateSupplierRequest:
            return { ...state, supplierRequest: { ...state.supplierRequest, ...payload } };
        case ACTION_TYPES.updateAddress:
            return { ...state, supplierRequest: { ...state.supplierRequest, address: { ...state.supplierRequest.address, ...payload } } };
        case ACTION_TYPES.updateContact:
            return { ...state, supplierRequest: { ...state.supplierRequest, contact: { ...state.supplierRequest.contact, ...payload } } };
        case ACTION_TYPES.updatePhysicalPerson:
            return { ...state, supplierRequest: { ...state.supplierRequest, physicalPerson: { ...state.supplierRequest.physicalPerson, ...payload } } };
        case ACTION_TYPES.updateLegalPerson:
            return { ...state, supplierRequest: { ...state.supplierRequest, legalPerson: { ...state.supplierRequest.legalPerson, ...payload } } };
        case ACTION_TYPES.setShowValidationErrors:
            return { ...state, showValidationErrors: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
